import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { CalendarDateFormatter, CalendarView } from 'angular-calendar';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { CalendarTypeService } from 'src/app/services/calendar-type.service';


@Component({
	selector: 'app-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: [ './calendar.component.css' ],
	providers: [
		{
			provide: CalendarDateFormatter,
			useClass: CustomDateFormatter,
		},
	]
})
export class CalendarComponent implements OnInit, OnDestroy {


	subscriptions = new Subscription();

	viewDate = new Date();
	excludeDays = [ 0, 6 ];

	bListMode = false;

	view: CalendarView = CalendarView.Month;

	bAdmin = this.authenticationService.isAdmin();

	isInternalCalendar = false;


	constructor(
		@Inject('LOCALSTORAGE') private localStorage: Storage,
		private authenticationService: AuthenticationService,
		private router: Router,
		private calendarTypeService: CalendarTypeService,
	) {
		const navigation = this.router.getCurrentNavigation();
		if( navigation && navigation.extras && navigation.extras.state ) {
			if( navigation.extras.state[ 'bList' ] ) {
				this.bListMode = true;
			}
		}
	}


	ngOnInit() {

		const storedType = this.localStorage.getItem('calendarType');
		if( storedType ) {
			this.isInternalCalendar = (storedType == 'internal');
			this.calendarTypeService.setInternalCalendar( this.isInternalCalendar );
		}

		const storedMode = this.localStorage.getItem('viewMode');
		if( storedMode ) {
			this.bListMode = (storedMode == 'list');
		}
		else {
			this.bListMode = false;
		}

		this.subscriptions.add(
			this.calendarTypeService.isInternalCalendar$.subscribe( isInternal => {

				this.isInternalCalendar = isInternal;
				this.localStorage.setItem('calendarType', isInternal ? 'internal' : 'external');

			})
		);

	}

	ngOnDestroy() {
		
		this.subscriptions.unsubscribe();

	}

	toggleMode() {
		this.bListMode = !this.bListMode;
		this.localStorage.setItem('viewMode', this.bListMode ? 'list' : 'calendar');
	}


}



